<template>
    <div class="container-launch-commissioning">
        <div class="container-launch-commissioning-header">
            <div class="title">Informar a porcentagem de comissão para corretores baseado no plano de pagamento.</div>
        </div>

        <div class="container-launch-commissioning-payment-charge">
            <div class="payment-charge-input">
                <ui-select-v2
                    v-model="form.data.payment_plan"
                    :data="paymentPlanOptions"
                    :show-footer="false"
                    design="mgb-15 br-all"
                    type="text"
                    label="Plano de Pagamento:"
                    item-label="label"
                    return-value="value"
                    required
                />
            </div>

            <div class="payment-charge-input" >
                <ui-select-v2
                    v-model="form.data.name"
                    :show-footer="false"
                    :data="groupOptions"
                    design="mgb-15 br-all"
                    label="Cargo:"
                    item-label="name"
                    return-value="name"
                    required
                />
            </div>

            <div class="payment-charge-input">
                <ui-input v-model="form.data.value" label="Comissão:" groupicon="fal fa-percent" required />
            </div>

            <div class="payment-charge-button">
                <ui-button
                    :disabled="!canAdd"
                    :loading="loading"
                    design="md primary"
                    @click="addCommission">
                    Adicionar
                </ui-button>
            </div>
        </div>

        <div class="container-launch-commissioning-table">
            <div class="commissioning-table">
                <ui-table-commissioning :contents="commissions" />
            </div>
        </div>

        <div class="container-launch-commissioning-footer">
            <ui-button design="md mw-150 success" @click="launchCreateSuccess">Avançar</ui-button>
        </div>

        <ui-launch-create-success-modal />
    </div>
</template>

<script>
	import { uiInput, uiSelectV2 } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { storage } from '@/services/storage'
	import { launchDay } from '@/services/axios'

	import { utilMixin, helpersMixin } from '@/mixins'

	import uiTableCommissioning from './table-commissioning'
	import uiLaunchCreateSuccessModal from '../launch-create-success-modal'

	import { mapGetters } from 'vuex'

	const defaultFormData = () => ({
		payment_plan: null,
		name: '',
		value: 0
	})

	export default {
		name: 'ui-launch-create-commissioning',

		components: {
			uiInput,
			uiButton,
			uiSelectV2,
			uiTableCommissioning,
			uiLaunchCreateSuccessModal
		},

		mixins: [utilMixin, helpersMixin],

		data() {
			return {
				form: {
					data: { ...defaultFormData() }
				},
				paymentPlanOptions: [],
				groupOptions: [],
				tableValues: [],
				commissions: [],
				loading: false
			}
		},

		computed: {
			...mapGetters('launchDay', { config: 'getConfig' }),
			/**
			 * Computed property que valida o formulário de cadastro das regras de comissionamento
			 * e decide se a regra pode ser salva
			 */
			canAdd() {
				return !!(this.$mx_hasValue(this.form.data.payment_plan) &&
					this.form.data.name &&
					this.$mx_hasValue(this.form.data.value))
			}
		},

		mounted() {
			this.$root.$on('modal-msg-event-launch-commissioning-method-delete', (payload) => {
				this.tableValues = Object.values(this.tableValues).map((value, index) => {
					if (parseInt(payload.data.value.indexPlans) === parseInt(index)) {
						value.commission.splice(payload.data.value.index, 1)
					}

					return value
				})

				this.saveComission()
			})

			this.loadForm()
		},

		methods: {
			/**
			 * Carrega os dados necessários para montar o formulário
			 */
			loadForm() {
				if (!this.config?.id) {
					this.$router.push({ name: 'launch.management.create.mainData' })
					return
				}

				if (this.config?.attributes?.tableValues && this.isJSON(this.config.attributes.tableValues)) {
					this.tableValues = [...JSON.parse(this.config.attributes.tableValues)]

					this.setData(this.tableValues)

					this.paymentPlanOptions = Object.values(this.tableValues).map((item, index) => {
						return { label: item.name, value: index }
					})
				}

				const supervisor = storage.get('label_supervisor') || 'Supervisor'
				const manager = storage.get('label_manager') || 'Gerente'
				const broker = storage.get('label_broker') || 'Corretor'
				this.groupOptions = [
					{ name: supervisor },
					{ name: manager },
					{ name: broker },
				]
			},
			/**
			 * Seta os dados das regras de comissionamento cadastradas para cada plano de pagamento
			 */
			setData(plans) {
				this.commissions = []
				for (const [pIndex, plan] of plans.entries()) {
					if (this.$mx_hasValue(plan.commission)) {
						for (const [index, commission] of [...plan.commission].entries()) {
							this.commissions.push({
								name: commission.name,
								group: commission.name,
								value: commission.value,
								index: index,
								indexPlans: pIndex
							})
						}
					}
				}
			},
			/**
			 * Adiciona os dados da regra de comissão ao plano de pagamento selecionado,
			 * de modo a atualizar o lançamento
			 */
			addCommission() {
				const index = this.form.data.payment_plan
				if (!this.tableValues[index].commission) this.tableValues[index].commission = []

				const commission = (({
					name,
					value
				}) => ({
					name,
					value
				}))(this.form.data)
				this.tableValues[index].commission.push(commission)
				this.saveComission()
			},
			/**
			 * Atualiza os dados do lançamento de modo a incluir ou remover regras de comissionamento
			 */
			saveComission() {
				this.loading = true
				let params = { ...this.config }
				params.attributes.tableValues = JSON.stringify(this.tableValues)
				launchDay.update('', params.id, params)
					.then(response => {
						this.setData(this.tableValues)
						this.form.data = { ...defaultFormData() }
						this.$toastr.s(response.data.msg)
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.loading = false
					})
			},
			/**
			 * Abre o modal de sucesso ao final do cadastro do lançamento
			 */
			launchCreateSuccess() {
				this.$root.$emit('modal-open-launch-create-success')
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>